import {AsyncInlineError, tracer} from '@s-ui/decorators/lib/index.js'
import {UseCase} from '@s-ui/domain'

import {HTTPTransactionRepository} from '../Repositories/HTTPTransactionRepository.js'
import {UpdateReservationPhoneNumberTransactionsRequest} from '../Requests/UpdateReservationPhoneNumberTransactionsRequest.js'

/**
 * @implements UseCase
 */

class UpdateReservationPhoneNumberTransactionsUseCase extends UseCase {
  #repository

  constructor({repository}) {
    super()
    this.#repository = repository
  }

  static create({config}) {
    return new UpdateReservationPhoneNumberTransactionsUseCase({
      repository: HTTPTransactionRepository.create({config})
    })
  }

  /**
   * @return {Promise<Object, Error>}
   */
  @tracer({metric: 'UpdateReservationPhoneNumberTransactionsUseCase#execute'})
  @AsyncInlineError()
  async execute({phoneNumber, reservationId}) {
    const requestVO = UpdateReservationPhoneNumberTransactionsRequest.create({
      buyerPaymentPhone: phoneNumber,
      reservationId
    })

    const [error, response] = await this.#repository.updateReservationPhoneNumber(requestVO)

    if (error) return Promise.reject(error)
    return response
  }
}

export const factory = UpdateReservationPhoneNumberTransactionsUseCase.create
